import React, {Component} from "react";

import { IS_VALID }       from "utils";

import View               from "./View";
import Update             from "../../PendingNotification/FormContainer/Update";

export default class FormContainer extends Component {
  render () {
    let {
      ScheduledNotification
    } = this.props;

    let {
      formType,
      selectedData
    } = ScheduledNotification;

    let updateProps = {
      reduxStateName: "ScheduledNotification",
      isScheduled: true,
      ...this.props
    };

    switch (formType.toUpperCase()) {
      case "VIEW":
        return <View {...this.props}/>
        break;
      case "UPDATE":
        return (
          <Update {...updateProps}/>
        );
        break;
      case "CANCEL":
        return (
          <p>
            Are you sure you want to cancel&nbsp;
            {IS_VALID(selectedData) && IS_VALID(selectedData.get("subject")) ? (
              <span style={{ color: "red" }}>{selectedData.get("subject")}</span>
            ) : (
              "this"
            )}
            &nbsp;push notification?
          </p>
        );
        break;
      default:
      return "";
    }
  }

  componentWillUnmount () {
    let {
      actions
    } = this.props;

    actions.setValue(
      {
        selectedData: null,
        formType: "",
        formId: "",
        formTitle: "",

        sendMode: {
      		value: "TEST",
      		label: "TEST"
      	},
        userType: {
      		value: 'MEMBER',
      		label: 'MEMBER'
      	},
        cardType: [],
        ageBracket: [35, 45],
        gender: null,
        device: {
      		value: 'ALL',
      		label: 'ALL'
      	},
        screen: null,
        browser: null,
        specificUser: [],
        blacklistedUser: [],

        subject: "",
        url: "",
        message: "",
        isSendNow: false,
      	scheduleDateTimeNotif: ""
      }
    );
  }
}



// WEBPACK FOOTER //
// ./components/ScheduledNotification/FormContainer/index.js